import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { EXTERNAL_BANK_ACCOUNT_LIST_BASE_KEY } from '@webapp/platform/banking/query-configs/externalBankAccount'
import { externalBankAccountRepository } from '../../../data-access/repositories/ExternalBankAccountRepository'

export const useMutateDeleteExternalBankAccount = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, number>({
    mutationFn: (id) => externalBankAccountRepository.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: EXTERNAL_BANK_ACCOUNT_LIST_BASE_KEY,
      })
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
  }
}
